import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import { getPaymentsRows, ProjectedPaymentsForm } from '../services';
import ProjectedPaymentsTable from './projected-payments-table';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

const useStyles = makeStyles((theme: any) => ({
  subTitle: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}));

type PatymentsSectionTableType = {
  methods: UseFormReturn<ProjectedPaymentsForm>,
  onEditMortgage: any,
  onEditEstimated: any,
  onEditPrincipalInterest: any,
  calculatedMortgageValue: number;
  calculatedEstimatedEscrow: number;
  calculatedPrincipalInterestValue: number;
  isMobile?: boolean;
  isSaving?: boolean;
}

const PaymentSectionTable = ({
  methods,
  onEditEstimated,
  onEditMortgage,
  onEditPrincipalInterest,
  calculatedEstimatedEscrow,
  calculatedMortgageValue,
  calculatedPrincipalInterestValue,
  isMobile = false,
  isSaving = false
}: PatymentsSectionTableType) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const fields = [
    'year_ranges',
    'principal_interest_amount',
    'interest_only',
    'mortgage_insurance',
    'estimated_escrow'
  ];
  return (
    <Grid container direction="column">
      <Grid item xs={12}>
        <Typography variant="body2" className={classes.subTitle}>
          {`${t('projectedPayments:years-range-title')}`}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <ProjectedPaymentsTable
          data={fields}
          isMobile={isMobile}
          idPrefix="projected-payments-payments"
          rows={getPaymentsRows({
            ...fields,
            methods,
            t,
            onEditMortgage,
            onEditEstimated,
            onEditPrincipalInterest,
            calculatedMortgageValue,
            calculatedEstimatedEscrow,
            calculatedPrincipalInterestValue,
            isSaving
          })}
        />
      </Grid>
    </Grid>
  );
};

export default PaymentSectionTable;
